/**
 * Hand a Trade Machine evaluation to the Trade Scorecard.
 *
 * The Trade Machine writes one of these to localStorage and navigates to the scorecard; the
 * scorecard reads it on load, creates the trade (players, chosen lineups, valuations, engine
 * record) and clears the key. Names are used for players because the Trade Machine works on
 * names; the scorecard maps them to salary-roster ids.
 */
export const HANDOFF_KEY = 'trade_scorecard_handoff';

export interface HandoffPlayer { player_id?: number | null; player_name: string }
export interface HandoffLineup {
  lineup_num: number;
  xi: HandoffPlayer[];                 // batting order
  sub?: HandoffPlayer | null;          // impact substitute (batter if present, else bowler)
  reg_bat_tv?: number | null; imp_bat_tv?: number | null; ns_bowl_tv?: number | null; sub_bowl_tv?: number | null;
}
export interface HandoffTeam {
  short: string; team_id: number;
  selections: string[];                // player names leaving this club
  lineup: HandoffLineup | null;        // the lineup the user picked for this club
  overall_bat_tv?: number | null; overall_bowl_tv?: number | null;   // post-trade, from the updated rankings
  original_bat_tv?: number | null; original_bowl_tv?: number | null; // pre-trade
  original_team_tv?: number | null; trade_team_tv?: number | null;
  original_rank?: number | null; trade_rank?: number | null;
}
export interface ScorecardHandoff {
  at: string; season: number | null; nLineups: number;
  teams: [HandoffTeam, HandoffTeam];
}

export function writeHandoff(h: ScorecardHandoff): void {
  window.localStorage.setItem(HANDOFF_KEY, JSON.stringify(h));
}
export function readHandoff(): ScorecardHandoff | null {
  try { const raw = window.localStorage.getItem(HANDOFF_KEY); return raw ? (JSON.parse(raw) as ScorecardHandoff) : null; } catch { return null; }
}
export function clearHandoff(): void { window.localStorage.removeItem(HANDOFF_KEY); }
